const BODY = "body"; //导航栏下面
const HEADER = "header"; //导航栏下面
// 产品详情轮播图下面
const DETAIL_UNDER_BANNER = ".body-container .container.container_clearpadding";

// 专题页嵌入banner下方
const SPEC_UNDER_BANNER = ".body-container>.p-l-banner-container_parent";

// 电脑眼镜专题页-steps to order下面
const COMPUTE_UDER_STEP_TO_ORDER = ".body-container>div>div>.row";
// HELP右侧,帮助中心
const HELP_ITEM_RIGHT = ".container.hc-body-container>.row>.col-sm-9";

// 产品详情描述下方
const DETAIL_UNDER_DESCRIPTION = "#pro-paras-container>.container";

// 专题页产品模块下方
const SPEC_UNDER_PRODUCTS = "#product_list_content";

// 产品颜色下方
const DETAIL_UNDER_COLORS =
    "#page > div.body-container > div.container.container_clearpadding > div.container";

// 视频下方
const DETAIL_UNDER_VIDEO = ".body-container .container.container_clearpadding";
// 专题页购物流程下面
const SPEC_SHOPPING_WAY = ".body-container>.container.text-center";
// 帮助中心底部
const HELP_BOTTOM_RIGHT = ".container.hc-body-container>.row>.col-sm-9";
// affiliate专题页底部
const AFFILIATE_BOTTOM = "#page>.container:last";
// affiliate专题banner下方
const AFFILIATE_BANNER_BOTTOM = ".container>.p-l-banner-container_parent";

export const embedPosition = {
    BODY,
    HEADER,
    DETAIL_UNDER_BANNER,
    SPEC_UNDER_BANNER,
    COMPUTE_UDER_STEP_TO_ORDER,
    HELP_ITEM_RIGHT,
    DETAIL_UNDER_DESCRIPTION,
    SPEC_UNDER_PRODUCTS,
    DETAIL_UNDER_COLORS,
    SPEC_SHOPPING_WAY,
    DETAIL_UNDER_VIDEO,
    HELP_BOTTOM_RIGHT,
    AFFILIATE_BOTTOM,
    AFFILIATE_BANNER_BOTTOM,
};

export const embedInitData: Partial<Record<keyof typeof embedPosition, any>> = {
    BODY: undefined,
    HEADER: undefined,
    DETAIL_UNDER_BANNER: undefined,
    SPEC_UNDER_BANNER: undefined,
    COMPUTE_UDER_STEP_TO_ORDER: undefined,
    HELP_ITEM_RIGHT: undefined,
    DETAIL_UNDER_DESCRIPTION: undefined,
    SPEC_UNDER_PRODUCTS: undefined,
    DETAIL_UNDER_COLORS: undefined,
    SPEC_SHOPPING_WAY: undefined,
    DETAIL_UNDER_VIDEO: undefined,
    HELP_BOTTOM_RIGHT: undefined,
    AFFILIATE_BOTTOM: undefined,
    AFFILIATE_BANNER_BOTTOM: undefined,
};
